// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bc4257e0","977":"3928d29d"}[chunkId] + ".chunk.js";
};